module.exports = __webpack_public_path__ + "static/media/ErsatzwagenKalender.38febdcb.png";